<template>
  <div class="container">
    <div class="left-title">电站信息管理</div>
    <div class="back" @click="backPrev">返回</div>
    <div class="right-container">
      <div class="right-top">
        <el-form ref="form" :model="form">
          <div
            style="width: 68vw; display: flex; justify-content: space-between"
          >
            <el-form-item label="区域：">
              <el-select
                v-model="form.psProvince"
                placeholder="请选择区域"
                style="width: 11vw"
              >
                <el-option label="区域一" value="shanghai"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="电站名称：">
              <el-input v-model="form.psName" style="width: 15.6vw" placeholder="请输入电站名称"></el-input>
            </el-form-item>
            <div style="display: flex; height: 4.6vh">
              <div class="query" @click="addNewStation">添加</div>
              <div class="query" @click="queryStation">查询</div>
              <div class="reset" @click="clearSearch">重置</div>
            </div>
          </div>
        </el-form>
      </div>
      <el-table
        :data="alarm"
        :header-cell-style="headerStyle"
        :cell-style="rowStyle"
      >
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="psName" label="电站名称"></el-table-column>
        <el-table-column prop="psProvince" label="区域"></el-table-column>
        <el-table-column prop="psAddress" label="详细地址"></el-table-column>
        <el-table-column prop="ownerName" label="业主姓名"></el-table-column>
        <el-table-column prop="ownerPhone" label="业主手机号"></el-table-column>
        <el-table-column prop="psOmName" label="维修服务商"></el-table-column>
        <el-table-column prop="psCapacity" label="装机容量"></el-table-column>
        <el-table-column prop="psCb" label="汇流箱(台)"></el-table-column>
        <el-table-column prop="psInverterCount" label="逆变器（台）"></el-table-column>
        <el-table-column prop="psTa" label="倾斜角度"></el-table-column>
        <el-table-column prop="psDc" label="排放量"></el-table-column>
        <el-table-column prop="psIq" label="指标值"></el-table-column>
        <el-table-column  label="电站类型">
            <template slot-scope="scope">
                <span v-if="scope.row.psType == 0">光伏站</span>
                <span v-if="scope.row.psType == 1">储能站</span>
            </template>
        </el-table-column>
        <!-- <el-table-column prop="remark" label="备注"></el-table-column> -->
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="text"
              @click="handleDelete( scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5,10,15,20]"
        :page-size="100"
        layout="sizes, prev, pager, next , total"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getStationInfoList,deleteStation } from "@/api/index";
export default {
  name: "stationInfo",
  data() {
    return {
      companyId: "", // 企业id
      form: {
        psProvince: "",
        psName: "",
      },
      alarm: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
    };
  },
  methods: {
    backPrev(){
        this.$router.push('/companyInfo')
    },
    headerStyle() {
      return "background:#0F2455;color:#fff;border: 1px solid #286AE8;text-align:center";
    },
    rowStyle() {
      return "background:#0F2455;color:#fff;border: 1px solid #286AE8;text-align:center";
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getInfo();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getInfo()
    },
    // 获取电站信息列表
    getInfo() {
      let data = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        psProvince: this.form.psProvince,
        psName: this.form.psName,
        etId: this.companyId,
      };
      getStationInfoList(data).then((res) => {
        this.alarm = res.rows;
        this.total = res.total;
      });
    },
    // 编辑
    handleEdit(row) {
      console.log(row, 111);
      let content = JSON.stringify(row);
      this.$router.push({
        path: "/addStationInfo",
        query: {
          id:this.companyId,
          content: content,
        },
      });
    },
    // 删除
    handleDelete(row) {
        let id = row.id
      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteStation(id).then(res => {
            if(res.code == 200){
                this.$message({
                    type: "success",
                    message: "删除成功!",
                });
            }
            this.getInfo()
        })
      });
    },
    // 跳转至新增页面
    addNewStation(){
        this.$router.push({
            path:'/addStationInfo',
            query:{
                id:this.companyId
            }
        })
    },
    // 查询
    queryStation(){
      this.getInfo()
    },
    // 重置
    clearSearch(){
      this.form.psName = ''
      this.form.psProvince = ''
      this.getInfo()
    }
  },
  mounted() {
    this.companyId = this.$route.query.id;
    console.log(this.companyId,'啊啊啊啊')
    this.getInfo();
  },
};
</script>

<style lang="scss" scoped>
.container::v-deep {
  margin-top: 2vh;
  width: 100%;
  position: relative;
  .left-title {
    position: absolute;
    left: 0;
    top: 0;
    background: url(@/assets/images/titleBg.png);
    background-size: 100% 100%;
    width: 11.1vw;
    height: 5.5vh;
    color: #fff;
    font-size: calc(100vw * 20 / 1920);
    text-align: center;
    line-height: 5.5vh;
    margin-right: 7.5vw;
  }
  .back {
    position: absolute;
    top: 8vh;
    background: url(@/assets/images/titleBg.png);
    background-size: 100% 100%;
    width: 11.1vw;
    height: 5.5vh;
    color: #fff;
    font-size: calc(100vw * 20 / 1920);
    text-align: center;
    line-height: 5.5vh;
    cursor: pointer;
  }
  .right-container {
    width: 68vw;
    position: absolute;
    left: 7vw;
    right: 0;
    margin: 0 auto;
    .right-top {
      margin: 0 auto;
      width: 100%;
      margin-bottom: 3vh;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-form-item {
        display: flex;
        align-items: center;
        height: 4.6vh;
        .el-select-dropdown__item .selected,
        .el-select-dropdown__item {
          font-size: calc(100vw * 16 / 1920);
        }
        .el-input__inner {
          width: 100%;
          height: 4.6vh;
          font-size: calc(100vw * 16 / 1920);
          box-shadow: inset 0rem 0rem 0.43rem 0.17rem rgba(44, 98, 230, 0.28);
          border-radius: 6px;
          border: 0.02rem solid #286ae8;
          background: none;
          color: #fff;
          &::placeholder {
            color: #fff;
          }
        }
        .el-form-item__label {
          width: 6vw;
          text-align: left;
          color: #fff;
          font-size: calc(100vw * 16 / 1920);
        }
      }
      .query,
      .reset {
        width: 7.2vw;
        height: 100%;
        background: url(@/assets/images/updown.png);
        background-size: 100% 100%;
        color: #02b5ff;
        font-size: calc(100vw * 16 / 1920);
        line-height: 4.6vh;
        text-align: center;
        cursor: pointer;
      }
      .query {
        margin-right: 1.5vw;
      }
    }
  }
}
::v-deep .el-table {
  width: 99.7%;
  margin-bottom: 2.5vh;
  font-size: calc(100vw * 16 / 1920);
}
::v-deep .el-table__body {
  font-size: calc(100vw * 14 / 1920);
}
.el-table--border::after,
.el-table--group::after,
.el-table::before {
  display: none;
}
::v-deep .el-pagination {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1vh;
}
::v-deep .el-pagination .el-select .el-input .el-input__inner,
::v-deep .el-pagination .btn-next,
::v-deep .el-pagination .btn-prev,
::v-deep .el-pager li,
::v-deep .el-pager li.btn-quicknext,
::v-deep .el-pager li.btn-quickprev,
::v-deep .el-pagination__total {
  background: #0f2455;
  border-radius: 6px;
  border: 1px solid #286ae8;
  color: #fff;
  text-align: center;
}
::v-deep .el-pager li,
::v-deep .el-pagination .btn-next,
::v-deep .el-pagination .btn-prev {
  margin-right: 0.5vw;
}
::v-deep .el-pagination__total {
  margin-right: 0;
  padding: 0 0.8vw;
  box-sizing: border-box;
}
::v-deep .el-pager li.active {
  color: #409EFF;
}
</style>
